module.exports = __webpack_public_path__ + "static/media/mmc.bcf4b2c3.webp";